export enum TextMatchStrategy {
  EXACT = 'exact',
  CONTAINS = 'contains',
  STARTSWITH = 'startsWith',
}

export enum BooleanMatchStrategy {
  CONVERT = 'convert',
}

export enum NumberMatchStrategy {
  CONVERT = 'convert',
}

export enum DateMatchStrategy {
  CONTAINS = 'contains',
}
